import { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import Tooltip from "@mui/material/Tooltip";
import ViewListIcon from "@mui/icons-material/ViewList";
import NotificationsIcon from "@mui/icons-material/Notifications";
import EmailIcon from "@mui/icons-material/Email";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";
import SuiBadge from "components/SuiBadge";
import DataTable from "examples/Tables/DataTable";
import SuiBadgeDot from "components/SuiBadgeDot";
import ContactAvatar from "components/UpStyled/ContactAvatar";

import Actionables from "components/UpStyled/Actionables";
import NumberFormat from "react-number-format";

import toast from "react-hot-toast";
import moment from "moment";
import { capitalCase } from "capital-case";
import { useForm, Controller } from "react-hook-form";

import { AccountContext } from "context/account";
import MyProjectsContext from "context/my-projects";
import CategoryContext from "context/category-context";

import { StoreContext } from "context/store";

import { compare } from "utils/helper";
import { getFileImage, getStyleImages, canResizeImageUrl } from "utils/imageHelper";
import { projectStatusOptions, create_links } from "utils/data";

import ProjectCard2 from "components/UpStyled/project-card/ProjectCard2";
import Prompt from "components/UpStyled/Prompt";
import api from "services/api";

import Conversations from "components/UpStyled/Conversations";
import EmptyProjectCard from "pages/de/project/components/EmptyProjectCard";
import EmptyStyleRecord from "pages/de/styles/components/EmptyStyleRecord";
import EmptyCollectionRecord from "pages/de/collection/components/EmptyCollectionRecord";
import NavigationCard from "pages/de/dashboard/components/NavigationCard";
import CollaboratorsBar from "pages/de/dashboard/components/CollaboratorsBar";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import RecentWorkCard from "pages/create/components/RecentWorkCard";
import NewBlogCard from "pages/de/dashboard/components/NewBlogCard";

import curved9 from "assets/images/upstyled/default_background.png";
import Calendar from "pages/de/dashboard/components/Calendar";
import RecentShares from "pages/de/dashboard/components/RecentShares";
import { Empty } from "antd";
import NotificationPanel from "pages/messages/notificationpanel";
import TabPanel from "components/UpStyled/TabPanel";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ToDoList from "pages/de/dashboard/components/ToDoList";
import NotificationCard from "pages/de/dashboard/components/NotificationCard";

import CollectionsIcon from "@mui/icons-material/Collections";
import StyleIcon from "@mui/icons-material/Style";
import PaletteIcon from "@mui/icons-material/Palette";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import PhotoAlbumIcon from "@mui/icons-material/PhotoAlbum";
import GroupsIcon from "@mui/icons-material/Groups";
import AddIcon from "@mui/icons-material/Add";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";

import AddEventModal from "pages/de/dashboard/components/AddEventModal";
import whiteCurved from "assets/images/curved-images/white-curved.jpeg";
import FileListView from "pages/de/dashboard/components/FileListView";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import { Paper } from "@mui/material";
import Stack from "@mui/material/Stack";

const smartdate = require("smartdate");
const MAX_RECENT_COUNT = 4;
const height = 320;
const width = 240;

const DashboardMA = () => {
  const [chats, setChats] = useState(new Map());
  const [projectList, setProjectList] = useState([]);
  const [projectCount, setProjectCount] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [currentEvents, setCurrentEvents] = useState([]);

  const [moodboards, setMoodboards] = useState([]);
  const [collectionList, setCollectionList] = useState([]);
  const [styleList, setStyleList] = useState({ hits: [] });
  const [collectionCount, setCollectionCount] = useState();
  const [styleCount, setStyleCount] = useState();
  const [moodboardCount, setMoodboardCount] = useState();
  const [ailabList, setAilabList] = useState([]);
  const [ailabCount, setAilabCount] = useState();
  const [postList, setPostList] = useState([]);
  const [postCount, setPostCount] = useState();

  const [blogsData, setBlogsData] = useState([]);
  const [calendarView, setCalendarView] = useState(false);
  const [addEventVisible, setAddEventVisible] = useState(false);
  const [selectedWorkIndex, setSelectedWorkIndex] = useState(4);
  const [messageTab, setMessageTab] = useState("message");

  const color = "dark";

  const navigate = useNavigate();
  const calCompRef = useRef(null);
  const calRef = useRef(null);
  const notificationRef = useRef(null);

  smartdate.init();

  const account = useContext(AccountContext);
  const {
    stagesProjects,
    prospects,
    removeMyFavoriteProject,
    addUnFavoriteProject,
    handleRefresh,
  } = useContext(MyProjectsContext);

  useEffect(() => {
    if (account.id) {
      handleRefresh();
      retrieveStyles();
      retrieveBlogs();
      retrieveMoodboards();
      retrieveCollections();
      retrieveAILabs();
      retrievePosts();
    }
  }, [account]);

  useEffect(() => {
    if (account.id) {
      retrieveProjects("active");
      retrieveChats();
    }
  }, [stagesProjects, account]);

  useEffect(() => {
    if (account.id) {
      retrieveEvents();
    }
  }, [account]);

  const newSelectedInfo = {
    date: moment().startOf("minute").toDate(),
    allDay: false,
    view: {
      calendar: calRef?.current?.getApi(),
    },
  };

  const retrieveEvents = async () => {
    let currentDate = moment();
    try {
      const temp = await api.calendar.listCalendars();
      const calendars = temp?.data?.calendars || [];
      let cids = calendars.map((x) => x.id);
      if (cids.length > 0) {
        const { data } = await api.calendar.listEvents({
          "start_time[gte]": currentDate.startOf("day").toISOString(),
          order: "start_time",
          type: "task",
          calendar_id: cids.join(":"),
        });

        let raw = data?.events || [];
        setCurrentEvents(raw);
      }
    } catch (err) {
      console.log(err);
      toast.error(`Could not retrieve tasks!`);
    }
  };

  const retrieveProjects = async (stage) => {
    let projects = [];
    if (stage == "prospects") {
      projects = prospects;
    } else {
      projects = stagesProjects[stage] || [];
    }

    const sortedProjects = projects.sort((a, b) => compare(a, b, "-updated_at"));
    setProjectCount(sortedProjects.length);
    setProjectList(sortedProjects);
  };

  const retrieveChats = async () => {
    try {
      api.chatroom.listChatRoom("project", "", "").then(({ data }) => {
        var chatrooms = new Map();
        for (const room of data.chats) {
          if (chatrooms.has(room.regardingid) && chatrooms.get(room.regardingid).ts > room.ts) {
            continue;
          }
          chatrooms.set(room.regardingid, room);
        }
        setChats(chatrooms);
        // console.log("chatrooms", chatrooms);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveBlogs = async () => {
    try {
      const { data } = await api.blog.homepage();
      setBlogsData(data?.blogs || []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleProjectRowClick = (row) => {
    let link = `/job/requests?id=${row?.original?.key}`;

    navigate(link);
    //window.open(`/workspace/styles-master?id=${row?.original?.key}`, "_blank");
  };

  const formatAccountStatus = (type, row) => {
    const option = projectStatusOptions.find((x) => x.value == type);
    if (option) {
      if (option.value == "init") {
        return <SuiBadgeDot color="warning" badgeContent={option.label} />;
      } else if (option.value == "requested") {
        return <SuiBadgeDot size="xs" color="info" badgeContent={option.label} />;
      } else if (option.value == "active") {
        return <SuiBadgeDot size="xs" color="success" badgeContent={option.label} />;
      } else if (option.value == "canceled") {
        return <SuiBadgeDot color="error" badgeContent={option.label} />;
      } else if (option.value == "completed") {
        return <SuiBadgeDot color="dark" badgeContent={option.label} />;
      } else if (row?.original?.deleted_at) {
        return (
          <Tooltip
            title={`Deleted at ${moment(row.original.deleted_at).format("YYYY-MM-DD")}`}
            placement="top"
          >
            <SuiBadgeDot color="error" badgeContent={"Deleted"} />
          </Tooltip>
        );
      } else {
        return <SuiBadgeDot color="secondary" badgeContent={option.label} />;
      }
    } else {
      return type;
    }
  };

  const getProjectTableRow = (item) => {
    const quote = item.quote ? item.quote : {};
    const products = item.products || [];
    let styleImages = [];
    //add style first image
    for (let i = 0; i < products.length; i++) {
      let temp = getStyleImages(products[i], false);
      styleImages.push(...temp);
    }
    //add all project reference image
    const fileList = item?.metadata?.["othersFiles"] || [];
    const files = fileList.filter((f) => f?.type && f.type.includes("image"));
    if (files && files.length > 0) {
      styleImages.push(...files);
    }
    if (styleImages.length == 0) {
      styleImages = [{ url: curved9, name: "deafult_image" }];
    }

    var room = chats && chats.has(item.id) ? chats.get(item.id) : null;

    const ownerStore =
      item?.owner?.stores && item.owner.stores.length > 0 ? item.owner.stores[0] : {};
    const ownerName = item?.store_name ? item?.store_name : ownerStore?.name;
    const DesignerCom =
      account.account_type == "ma" ? (
        <SuiBox
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          gap={1}
          sx={{ maxWidth: 360 }}
        >
          <SuiBox>
            <Tooltip position="top" title={ownerName}>
              <SuiAvatar
                src={ownerStore?.metadata?.avatar}
                alt="profile-image"
                variant="rounded"
                size="sm"
                shadow="sm"
              />
            </Tooltip>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="regular" textTransform="capitalize">
              {ownerName}
            </SuiTypography>
          </SuiBox>
        </SuiBox>
      ) : null;

    return {
      key: item.id,
      image: styleImages[0],
      name: item.name,
      budget: quote.budget,
      budget_min: quote.budget_min,
      budget_max: quote.budget_max,
      desired_end_date: quote.desired_end_date,
      created_at: item.created_at,
      deleted_at: item.deleted_at,
      status: item.status,
      room: room,
      DesignerCom: DesignerCom,
    };
  };

  const projectColumns = [
    {
      Header: "Image",
      accessor: "image",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <Link to={`/job/requests?id=${row?.original?.key}`}>
            <ImageCardWrapper data={value} mode={"normal"} height={40} width={40} iconMode />
          </Link>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return <div className="max-w-[240px]">{value}</div>;
      },
    },
    {
      Header: "status",
      accessor: "status",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => formatAccountStatus(value, row),
    },
    {
      Header: "Budget",
      accessor: "budget",
      isSorted: false,
      canSort: false,
      Cell: ({ row }) => {
        return (
          <div className="flex flex-nowrap">
            <NumberFormat
              value={row?.original?.budget_min}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
              renderText={(value, props) => (
                <SuiTypography variant="body1" fontWeight="regular" color="text" {...props}>
                  {value}
                </SuiTypography>
              )}
            />
            ~{" "}
            <NumberFormat
              value={row?.original?.budget_max}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
              renderText={(value, props) => (
                <SuiTypography variant="body1" fontWeight="regular" color="text" {...props}>
                  {value}
                </SuiTypography>
              )}
            />
          </div>
        );
      },
    },
    {
      Header: "Desired End Date",
      accessor: "desired_end_date",
      Cell: ({ row, value }) => {
        return <div>{moment(value).format("YYYY-MM-DD")}</div>;
      },
    },
    {
      Header: "Message",
      accessor: "room",

      Cell: ({ row, value }) => {
        const room = value;
        return room ? (
          <SuiBox className="flex items-center" sx={{ maxWidth: 360 }}>
            <SuiBadge variant="dot" color="error" invisible={room.ts <= room.viewts}>
              <ContactAvatar room={room} />
            </SuiBadge>
            <div className="w-full">
              <div className="flex justify-between items-center">
                <SuiTypography
                  variant="body1"
                  fontWeight="bold"
                  textTransform="capitalize"
                  className={`block ml-2 text-gray-600 font-semibold`}
                >
                  {room.name}
                </SuiTypography>
                <SuiTypography variant="caption" className={`block ml-2 text-gray-600`}>
                  {smartdate.format(new Date(room.ts))}
                </SuiTypography>
              </div>
              <div className="flex justify-between">
                <SuiTypography
                  className={`ml-2 text-gray-600`}
                  variant="caption"
                  textTransform="none"
                  color="secondary"
                  lineHeight="1.2"
                  sx={{
                    width: "100%",
                    minHeight: "28px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {room.lastcontent}
                </SuiTypography>
              </div>
            </div>
          </SuiBox>
        ) : (
          row?.original?.DesignerCom
        );
      },
    },
  ];

  const projectRows = projectList.map((item) => getProjectTableRow(item));

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
      value: index,
    };
  }

  const retrieveStyles = async () => {
    const payload = {
      q: "",
      sort: ["updated_at:desc"],
    };

    try {
      const { data } = await api.products.searchStyles(payload);
      setStyleList(data ? data : { hits: [], nbHits: 0 });
      setStyleCount(data?.estimatedTotalHits);
    } catch (err) {
      toast.error(`Retrieve style list failed`);
      console.log(err);
    }
  };
  const retrieveMoodboards = async () => {
    try {
      const { data } = await api.moodboard.list();
      let myMoodboard = data?.moodboards || [];
      myMoodboard = myMoodboard.sort((a, b) => compare(a, b, "-updated_at"));

      setMoodboardCount(myMoodboard.length);

      setMoodboards(myMoodboard);
    } catch (err) {
      toast.error(`Retrieve moodboards failed!`);
      console.log(err);
    }
  };

  const retrieveCollections = async () => {
    try {
      const { data } = await api.collections.list({
        order: "-updated_at",
      });

      let collections = data["collections"] ? data["collections"] : [];
      setCollectionCount(collections.length);

      collections = collections;

      setCollectionList(collections);
    } catch (err) {
      toast.error(`Retrieve collection list failed`);
      console.log(err);
    }
  };

  const retrieveAILabs = async () => {
    try {
      const { data } = await api.ailab.list();
      let myAILab = data?.ailabs || [];
      myAILab = myAILab.sort((a, b) => compare(a, b, "-updated_at"));
      setAilabCount(myAILab.length);

      setAilabList(myAILab);
    } catch (err) {
      toast.error(`Retrieve ailabs failed!`);
      console.log(err);
    }
  };

  const retrievePosts = async (offset, limit) => {
    try {
      const { data } = await api.post.list({ order: "-updated_at" });
      const allPosts = data?.posts || [];

      setPostList(allPosts);

      setPostCount(allPosts.length);
    } catch (err) {
      console.log(err);
    }
  };

  const quick_link = [
    {
      title: "AI Designs",
      link: "/workspace/fashion-lab",
      icon: <CollectionsIcon fontSize="small" color="inherit" />,
      count: ailabCount,
      data: ailabList,
      type: "ailab",
    },
    {
      title: "Moodboards",
      link: "/workspace/moodboard",
      icon: <PaletteIcon fontSize="small" color="inherit" />,
      count: moodboardCount,
      data: moodboards,
      type: "moodboard",
    },
    {
      title: "Tech Packs",
      link: "/workspace/styles-detail?stage=tech-pack",
      icon: <DesignServicesIcon fontSize="small" color="inherit" />,
      count: styleCount,
      data: styleList.hits || [],
      type: "style",
    },
    {
      title: "My Posts",
      link: "/post/create",
      icon: <PhotoAlbumIcon fontSize="small" color="inherit" />,
      count: postCount,
      data: postList,
      type: "post",
      status: [
        { label: "Draft", value: "draft" },
        { label: "Published", value: "published" },
      ],
      initialStatus: "draft",
    },
    {
      title: "Projects",
      icon: <PrecisionManufacturingIcon fontSize="small" color="inherit" />,
      count: projectCount,
      data: projectList,
      type: "project",
      status: [
        { label: "Ongoing", value: "active" },
        { label: "Completed", value: "completed" },
        { label: "Canceled", value: "canceled" },
      ],

      initialStatus: "active",
    },
  ];

  return (
    <SuiBox>
      <Grid
        container
        spacing={2}
        alignItems="stretch"
        justifyContent="space-around"
        sx={{ mt: 0.5 }}
      >
        <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
          <SuiBox display="flex" flexDirection="column" height="100%" alignItems="flex-start">
            <SuiBox width="100%">
              <Grid
                container
                columnSpacing={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 1 }}
                sx={{ mt: 0.5 }}
              >
                {quick_link.map((item, index) => (
                  <Grid item xs={6} sm={6} md={6} lg={4} xl={2.4}>
                    <Card
                      sx={({ functions: { linearGradient, rgba }, palette: { gradients } }) => ({
                        backgroundImage:
                          index == selectedWorkIndex
                            ? gradients[color]
                              ? `${linearGradient(
                                  rgba(gradients[color].main, 0.85),
                                  rgba(gradients[color].state, 0.85)
                                )}, url(${whiteCurved})`
                              : `${linearGradient(
                                  rgba(gradients[color].main, 0.85),
                                  rgba(gradients[color].state, 0.85)
                                )}, url(${whiteCurved})`
                            : "none",
                        backgroundSize: "cover",
                        backgroundPosition: "50%",
                        overflow: "visible",
                        maxWidth: 365,
                        cursor: "pointer",
                        mb: 1,
                        borderRadius: 2,
                      })}
                      onClick={() => setSelectedWorkIndex(index)}
                      // onClick={() => (item.link ? navigate(item.link) : null)}
                    >
                      <SuiBox
                        sx={{ px: 1, py: 1, display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <SuiBox
                          variant="gradient"
                          bgColor={index == selectedWorkIndex ? "white" : "dark"}
                          color={index == selectedWorkIndex ? "dark" : "white"}
                          width="2rem"
                          height="2rem"
                          borderRadius="md"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          shadow="md"
                        >
                          {item.icon}
                        </SuiBox>

                        <SuiBox lineHeight={1}>
                          <SuiTypography
                            variant="button"
                            color={index == selectedWorkIndex ? "white" : "text"}
                            textTransform="capitalize"
                            sx={{ letterSpacing: "normal", lineHeight: 1.2 }}
                          >
                            {item.title}
                          </SuiTypography>
                          <SuiTypography
                            variant="h6"
                            sx={{ letterSpacing: "normal", ml: 0.5, lineHeight: 1.2 }}
                            fontWeight="bold"
                            color={index == selectedWorkIndex ? "white" : "dark"}
                          >
                            {item.count}
                          </SuiTypography>
                        </SuiBox>
                      </SuiBox>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </SuiBox>
            <Card
              sx={{
                flexGrow: "1",
                width: "100%",
                my: 1,
                height: { xs: 400, sm: 400, md: 400, lg: 400, xl: 500 },
                overflow: "auto",
              }}
            >
              <SuiBox display="flex" gap={1} height="100%">
                <SuiBox sx={{ width: "100%", height: "100%" }}>
                  <FileListView data={quick_link[selectedWorkIndex]} />
                </SuiBox>
              </SuiBox>
              {/* <NotificationCard /> */}
            </Card>
          </SuiBox>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5} xl={5} sx={{ height: "100%" }}>
          <AppBar position="relative" sx={{ width: "100%" }}>
            <Tabs
              orientation={"horizontal"}
              value={tabValue}
              onChange={handleSetTabValue}
              sx={{ width: "100%" }}
            >
              <Tab label="To-Do List" {...a11yProps(0)} icon={<ViewListIcon />} />
              {/* <Tab label="Notification" {...a11yProps(1)} icon={<NotificationsIcon />} /> */}
              <Tab label="Calendar" {...a11yProps(2)} icon={<CalendarMonthIcon />} />
              <Tab
                label={
                  <SuiTypography
                    sx={{ display: { xs: "none", sm: "block", md: "none", lg: "block" } }}
                  >
                    Collaboration
                  </SuiTypography>
                }
                {...a11yProps(3)}
                icon={<GroupsIcon fontSize="medium" />}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={tabValue} index={0}>
            <Card sx={{ height: 550, pt: 2 }}>
              <ToDoList
                currentEvents={currentEvents}
                handleRefresh={() => {
                  retrieveEvents();
                  calCompRef?.current?.retrieveEvents();
                }}
                handleChangeCalendarView={setCalendarView}
                calRef={calRef}
              />
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <Card sx={{ height: 550, maxHeight: 550 }}>
              <Calendar
                handleAfterChange={() => {
                  retrieveEvents();
                  notificationRef?.current?.refresh();
                }}
                ref={calCompRef}
                calRef={calRef}
              />
            </Card>
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <RecentShares sx={{ height: 550, maxHeight: 550 }} />
          </TabPanel>
        </Grid>
        <Grid
          container
          spacing={2}
          alignItems="stretch"
          justifyContent="space-around"
          sx={{ mt: 0.5 }}
        >
          <Grid item xs={12} lg={12}>
            <Card sx={{ px: 3, py: 2 }}>
              <SuiBox mb={1}>
                <SuiTypography variant="h5" textTransform="capitalize">
                  Blogs
                </SuiTypography>
              </SuiBox>
              <SuiBox
                display="flex"
                overflow="auto"
                gap={1}
                p={1}
                sx={{
                  alignItems: "stretch",
                }}
              >
                {blogsData.length > 0 ? (
                  blogsData.map((blog, index) => (
                    <SuiBox sx={{ width: 320, minWidth: 320, m: 1 }}>
                      <NewBlogCard blog={blog} index={index} />
                    </SuiBox>
                  ))
                ) : (
                  <div style={{ width: "100%" }}>
                    <Empty description={null} />
                  </div>
                )}
              </SuiBox>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      {addEventVisible ? (
        <AddEventModal
          visible={addEventVisible}
          selectInfo={newSelectedInfo}
          handleClose={() => setAddEventVisible(false)}
          handleRefresh={() => {
            retrieveEvents();
            calCompRef?.current?.retrieveEvents();
          }}
          selectedType={"task"}
        />
      ) : null}
    </SuiBox>
  );
};

export default DashboardMA;
